import { useGetEmergencyPosts } from '@/features/api/hooks/grapevine-post/useGetEmergencyPosts';
import { useGetMinistryPosts } from '@/features/api/hooks/grapevine-post/useGetMinistryPosts';
import { useGetMyRegionEvents } from '@/features/api/hooks/grapevine-post/useGetMyRegionEvents';
import { useGetRegionalfunkPosts } from '@/features/api/hooks/grapevine-post/useGetRegionalfunkPosts';
import { DEFAULT_EVENTS_RADIUS_KM } from '@/features/geo-area/components/region/regionOptions';
import {
  RegionTab,
  type RegionFilterChange
} from '@/features/geo-area/components/region/regionTypes';
import { useRegionParams } from '@/features/geo-area/hooks/useRegionParams';
import { useRegionalfunkRadiusStore } from '@/features/geo-area/store/useRegionalfunkRadiusStore';

export const useMeineRegionPostFeed = (
  activeTab: RegionTab,
  filter: RegionFilterChange | undefined,
  homeAreaId: string | undefined
) => {
  const params = useRegionParams(activeTab, filter);
  const radiusKm = useRegionalfunkRadiusStore((s) => s.meineRegionRadiusKm);

  const ministryQuery = useGetMinistryPosts({
    homeAreaId,
    enabled: activeTab === RegionTab.MINISTRIES
  });
  const emergencyQuery = useGetEmergencyPosts({ homeAreaId, radiusKm });
  const eventsQuery = useGetMyRegionEvents({
    radiusKm: params.radiusKm ?? DEFAULT_EVENTS_RADIUS_KM,
    homeAreaId,
    enabled: activeTab === RegionTab.EVENTS
  });
  const regionalfunkQuery = useGetRegionalfunkPosts({
    radiusKm,
    homeAreaId,
    enabled: activeTab === RegionTab.REGIONAL_RADIO
  });

  const queries = {
    [RegionTab.MINISTRIES]: ministryQuery,
    [RegionTab.EMERGENCY]: emergencyQuery,
    [RegionTab.EVENTS]: eventsQuery,
    [RegionTab.REGIONAL_RADIO]: regionalfunkQuery
  };

  return {
    params,
    query: queries[activeTab],
    emergencyPosts: emergencyQuery.data
  };
};
